import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { PanierService } from 'src/app/services/manage/panier/panier.service';
import { PointofsaleService } from 'src/app/services/api/pointofsale/pointofsale.service';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-side-data-order',
  templateUrl: './side-data-order.component.html',
  styleUrls: ['./side-data-order.component.css']
})
export class SideDataOrderComponent implements OnInit {

  @Input() order: any

  @Output() closeSideEvent = new EventEmitter<any>();

  loaders: any = {
    banner: true
  };

  constructor(
    private panMan: PanierService,
    private posApi: PointofsaleService,
    public tools: ToolsService
  ) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["order"].currentValue) {
      this.parseData();
    }
  }

  parseData() {


    this.loaders.banner = true;
   
    this.posApi.$_getDefaultBanner(this.order.point_of_sale, false, this.order.user_account.id_webshop).then(parsedData => {
   
    
      this.order.point_of_sale = parsedData;
      this.order.basket.map((prod :any)=> {
        prod.total_ttc = this.panMan.getProdTotal(prod);
       
      });
      this.loaders.banner = false;
    })
  }

  goOrderAgain() {
    const splitedUrl = window.location.href.split("/home");
    window.open(splitedUrl[0] + "/s/" + this.order.id, '_blank');
  }

  goPrint() {
    window.open("http://pandor-201115.appspot.com/orders/dashboard/commande.html?user=" + this.order.user_account.user_key + "&id=" + this.order.id, "_blank");
  }

  /**
   * Redirige vers la page de suiv_i de colis mondial relay
   */
  openTrackingLink(): void {
    window.open(this.order.tracking_link, "_blank");
  }

  closeSide() {
  
    this.closeSideEvent.emit();
  }



}
